import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { ERROR, openNotification } from "../../utils";

const LOAD_HISTORICO_LABORAL = "[EXPLABORAL] LOAD_HISTORICO_LABORAL";
const LOADING = "[EXPLABORAL] LOADING";
const LOADING_FORM = "[EXPLABORAL] LOADING_FORM";
const CLEAN_STATE_LAB = "[EXPLABORAL] CLEAN_STATE_LAB";
const SET_FORMULARIO = "[EXPLABORAL] SET_FORMULARIO";
const SET_FORMULARIO_CLEAN = "[EXPLABORAL] SET_FORMULARIO_CLEAN";
const IS_ACTIVE_EXP_LABORAL = "[EXPLABORAL] IS_ACTIVE_EXP_LABORAL";

//------------- STATE -------------------------
const initialState = {
  expLaboral: [],
  loading: false,
  loadingForm: false,
  activeExpLaboral: {},
  statusForm: {
    isSaved: false,
    isError: false,
    mensaje: null,
  },
};

//------------- REDUCER -------------------------
const expLaboralReducer = (state = initialState, action) => {
  switch (action.type) {

    case LOAD_HISTORICO_LABORAL:
      return {
        ...state,
        expLaboral: [...action.payload],
      };

    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case LOADING_FORM:
      return {
        ...state,
        loadingForm: action.payload,
      };
    case SET_FORMULARIO:
      return {
        ...state,
        statusForm: {
          isSaved: action.payload.isSaved,
          isError: action.payload.isError,
          mensaje: action.payload.message,
        },
      };

    case SET_FORMULARIO_CLEAN:
      return {
        ...state,
        statusForm: {
          isSaved: false,
          isError: false,
          mensaje: null,
        },
      };

    case IS_ACTIVE_EXP_LABORAL:
      return {
        ...state,
        activeExpLaboral: {
          ...action.payload,
        },
      };
    case CLEAN_STATE_LAB:
      return initialState;

    default:
      return state;
  }
};

export default expLaboralReducer;

//------------- ACTIONS -------------------------

export const setHistorialLaboral = (state) => ({
  type: LOAD_HISTORICO_LABORAL,
  payload: state,
});

export const setLoading = (state) => ({
  type: LOADING,
  payload: state,
});

export const cleanStateLab = () => ({
  type: CLEAN_STATE_LAB,
});

const setLoadingForm = (status) => ({
  type: LOADING_FORM,
  payload: status,
});

export const setFormulario = (isError, isSaved, message) => ({
  type: SET_FORMULARIO,
  payload: {
    isError,
    message,
    isSaved,
  },
});

export const setFormularioClean = () => ({
  type: SET_FORMULARIO_CLEAN,
});

export const isActiveExpLaboral = (state) => ({
  type: IS_ACTIVE_EXP_LABORAL,
  payload: state,
});

/**
 * @returns Obetener historico de exp. laboral del aspirante
 */
export const getExpLaboralById = () => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    const { accessToken, idAspirante } = getState().usuarioLogin;
    const { data } = await axios(window.location.origin + JSON_URL);

    await axios
      .post(
        `${data.urlServer}${data.urlObtenerExpLaboral}`,
        { idAspirante },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      .then((resp) => {
        const { data } = resp;
        dispatch(setHistorialLaboral(data));
      })
      .catch((error) => {
        const { data } = error.response;
        openNotification("error", ERROR, data.mensaje);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  } catch (error) {
    console.error(error);
  }
};

export const removeExpLaboralById = (id) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    const { accessToken, idAspirante } = getState().usuarioLogin;
    const { data } = await axios(window.location.origin + JSON_URL);

    await axios
      .post(
        `${data.urlServer}${data.urlEliminaExpLaboral}`,
        { idExperiencia: id, idAspirante },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((resp) => {
        const { data } = resp;
        if (data.idMensaje === 1) {
          dispatch(getExpLaboralById());
          openNotification("success", "Éxito", data.mensaje);
        }
      })
      .catch((error) => {
        const { data } = error.response;
        openNotification("error", ERROR, data.mensaje);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  } catch (error) {
    console.error(error);
  }
};

export const saveExpLaboral = (formData) => async (dispatch, getState) => {
  dispatch(setLoadingForm(true));

  const { data } = await axios(window.location.origin + JSON_URL);
  const { accessToken } = getState().usuarioLogin;

  await axios
    .post(`${data.urlServer}${data.urlGuardarExpLaboral}`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((resp) => {
      const { data } = resp;
      if (data.idMensaje === 1) {
        dispatch(setFormulario(false, true, data.mensaje));
        dispatch(getExpLaboralById());
      } else {
        dispatch(setLoadingForm(false));
        dispatch(setFormulario(true, false, data.mensaje));
      }
    })
    .catch((error) => {
      const { data } = error.response;
      dispatch(setLoadingForm(false));
      dispatch(setFormulario(true, false, data.mensaje));
    })
    .finally(() => {
      dispatch(setLoadingForm(false));
    });
};

export const updateExpLaboral = (formData) => async (dispatch, getState) => {
  dispatch(setLoadingForm(true));

  const { data } = await axios(window.location.origin + JSON_URL);
  const { accessToken } = getState().usuarioLogin;

  await axios
    .post(`${data.urlServer}${data.urlActualizarExpLaboral}`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((resp) => {
      const { data } = resp;
      if (data.idMensaje === 1) {
        dispatch(setFormulario(false, true, data.mensaje));
        dispatch(isActiveExpLaboral({}));
        dispatch(getExpLaboralById());
      } else {
        dispatch(setLoadingForm(false));
        dispatch(setFormulario(true, false, data.mensaje));
      }
    })
    .catch((error) => {
      const { data } = error.response;
      dispatch(setLoadingForm(false));
      dispatch(setFormulario(true, false, data.mensaje));
    })
    .finally(() => {
      dispatch(setLoadingForm(false));
    });
};
